import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Principal from './Principal';
import VerificacionEmail from './pages/VerificacionEmail';
import AdminLayout from './pages/admin/AdminLayout';
import Restablecer from './Restablecer'; // 👈 IMPORTAR EL COMPONENTE
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Principal />} />
        <Route path="/verificar-email" element={<VerificacionEmail />} />
        <Route path="/restablecer" element={<Restablecer />} /> {/* 👈 NUEVA RUTA */}
        <Route path="/admin/*" element={<AdminLayout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;